import dynamic from 'next/dynamic';
import { useReducer, useState } from 'react';

import Home from '../Home';
import { Store, reducer, initialState } from '../../store';

import useStyles from './styles';

const Editor = dynamic(() => import('../Editor'), { loading: () => null });

function App() {
  useStyles();
  const [state, dispatch] = useReducer(reducer, initialState);
  const [hexColor, setHexColor] = useState<string | null>(null);
  const [showHomepage, setShowHomepage] = useState(true);

  return (
    <Store.Provider value={{ state, dispatch }}>
      {showHomepage ? (
        <Home hexColor={hexColor} setHexColor={setHexColor} setShowHomepage={setShowHomepage} />
      ) : (
        <Editor color={hexColor ?? null} />
      )}
    </Store.Provider>
  );
}

export default App;
